import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	SimpleChanges
} from '@angular/core';

import { PlaybackOption } from './PlaybackOption';

export const START_AT_WIGGLE_ROOM_MS: number = 1000;

@Component({
	selector: 'vb-start-at-manager',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: ``
})
export class VbStartAtManagerComponent implements OnChanges {
	@Input() public currentTime: number;
	@Input() public playbackOptions: PlaybackOption[];
	@Input() public startAt: number;
	@Input() public startAtResume: boolean;
	@Input() public totalTime: number;

	private _isNoResumeActive: boolean = false;
	private _isStartAtSeeking: boolean = false;

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.playbackOptions || changes.startAt) {
			this._isStartAtSeeking = !!this.startAt;
			this._isNoResumeActive = !this.startAtResume && !!this.startAt;
		}

		if (changes.currentTime || changes.totalTime) {
			this.onCurrentTimeChange();
		}
	}

	public get isNoResumeActive(): boolean {
		return this._isNoResumeActive;
	}

	public get isStartAtSeeking(): boolean {
		return this._isStartAtSeeking;
	}

	private onCurrentTimeChange(): void {
		const startAtMs: number = (this.startAt || 0) * 1000; // sec => ms

		if (this._isStartAtSeeking) {
			this._isStartAtSeeking =
				!this.totalTime ||
				!(
					this.currentTime > startAtMs ||
					(startAtMs - this.currentTime) <= START_AT_WIGGLE_ROOM_MS
				);
		}

		if (this._isNoResumeActive) {
			this._isNoResumeActive = this.currentTime < startAtMs + START_AT_WIGGLE_ROOM_MS;
		}
	}
}
